import { apiGet, apiPost } from './conserv'
import store from '@/store'

// Rota nova, multi-portal. A antiga (api/CnSyncFinal) segue respondendo no
// backend, mas todo o frontend passa a usar esta.
const BASE = 'api/SyncFinal'

// Portais com sincronização de resultado final implementada no worker.
// 1 = ComprasNet, 2 = Licitações-e legado, 4 = PCP, 5 = BLL, 7 = Licitanet, 8 = BNC, 9 = ComprasBR
// (2, 7 e 9 liberados para todos em 18/10/2026).
export const PORTAIS_SYNC_FINAL = [1, 2, 4, 5, 7, 8, 9]

// Portais com sincronização final em teste: o botão só aparece para os CNPJs listados (hoje vazio).
// ATENÇÃO: a API tem a mesma regra (PortaisSyncFinalHelper.cs / PortaisAlertaConfigHelper.PortaisRestritos) — ao restringir
// um portal de novo, alterar os dois lados.
export const PORTAIS_SYNC_FINAL_RESTRITOS = {
  10: ['52386933000162'], // Licitar Digital: em homologação (18/10/2026)
  11: ['52386933000162'], // AMM Licita: mesmo sistema do Licitar Digital (22/10/2026)
  12: ['52386933000162'], // Publinexo: em homologação (18/10/2026)
}

const soDigitos = (v) => String(v ?? '').replace(/\D/g, '')

export function portalTemSyncFinal(idportal, cnpj = '') {
  const id = Number(idportal)
  if (PORTAIS_SYNC_FINAL.includes(id)) return true
  const permitidos = PORTAIS_SYNC_FINAL_RESTRITOS[id]
  return !!permitidos && permitidos.includes(soDigitos(cnpj))
}

// BLL (5) e BNC (8) guardam em idregportal uma chave composta, não o token do
// portal. O token vem de linkdet — e sem ele o worker não tem como abrir o
// pregão. Pregão cadastrado manualmente nasce com linkdet vazio.
const PORTAIS_TOKEN_EM_LINKDET = [5, 8]

function temTokenDoPortal(row) {
  if (!PORTAIS_TOKEN_EM_LINKDET.includes(Number(row.idportal))) return true

  // Em alguns registros o próprio idregportal já traz o token cru ou escapado.
  const idreg = String(row.idregportal || '')
  return !!row.linkdet || idreg.includes('[gkz]') || idreg.includes('%5Bgkz%5D')
}

export function suportaSyncFinal(row) {
  // Licitações-e 2.0 (BB2) usa outra plataforma: o resultado final do web lê só o legado (BB1)
  if (row && Number(row.idportal) === 2 && String(row.nomeportal ?? '').includes('2.0')) return false

  return !!row
    && portalTemSyncFinal(row.idportal, store.getters.cnpjAtivo)
    && !!row.idregportal
    && temTokenDoPortal(row)
}

export function adicionarFilaSync(idRegPortal) {
  return apiPost(`${BASE}/AdicionarFila`, { idRegPortal })
}

export function statusSync(idRegPortal) {
  return apiGet(`${BASE}/Status/${idRegPortal}`)
}

export function statusSyncBatch(ids) {
  return apiPost(`${BASE}/StatusBatch`, ids)
}

export function resetarSync(idRegPortal) {
  return apiPost(`${BASE}/Resetar`, { idRegPortal })
}

export function detalhesSync(jobId) {
  return apiGet(`${BASE}/Detalhes/${jobId}`)
}

export function listaSync(pagina, tamanho) {
  return apiGet(`${BASE}/Lista?pagina=${pagina}&tamanho=${tamanho}`)
}
